<agpr-dialog-container
    id="AIRefinementDialog"
    class="agpr-aiRefinementDialog"
    [heading]="'Common.forms.richText.aiRefinementDialog.header'"
    headingIcon="fa-kit-duotone fa-agpr-ai"
    [hideFooter]="!streamingStarted"
    [contentPadding]="false"
    (close)="cancel()"
>
    <agpr-scroll-panel>
        <!-- before streaming start -->
        <div
            *ngIf="!streamingStarted"
            class="agpr-aiRefinementDialog-content agpr-aiRefinementDialog-content-prompt"
        >
            <agpr-ai-prompt-suggestion
                [prompt]="prompt"
                (submitPrompt)="submitRefinementPrompt($event)"
            >
            </agpr-ai-prompt-suggestion>
        </div>

        <!-- after streaming start -->
        <div
            *ngIf="streamingStarted"
            class="agpr-aiRefinementDialog-content"
        >
            <div
                class="agpr-aiRefinementDialog-generated-topSection"
            >
                <agpr-button
                    id="agpr_aiRefinementDialog_stopStreaming"
                    class="agpr-aiRefinementDialog-plainButton agpr-aiRefinementDialog-generated-topSection-back"
                    [style]="buttonTypes.icon"
                    [icon]="'fa-regular fa-arrow-left'"
                    tooltip="Common.dialog.aiRefinement.changePrompt"
                    tooltipPosition="left"
                    ariaLabel="Common.dialog.aiRefinement.changePrompt"
                    (click)="stopStreaming()"
                ></agpr-button>

                <div class="agpr-aiRefinementDialog-generated-topSection-label">
                    {{ prompt | localize }}
                </div>
                <agpr-button
                    id="agpr_aiRefinementDialog_regenerate"
                    class="agpr-aiRefinementDialog-plainButton agpr-aiRefinementDialog-generated-topSection-redo"
                    [style]="buttonTypes.icon"
                    [icon]="'fa-duotone fa-regular fa-arrow-rotate-right'"
                    [tooltip]="'Common.dialog.aiRefinement.regenerate'"
                    tooltipPosition="left"
                    [ariaLabel]="'Common.dialog.aiRefinement.regenerate'"
                    ariaControls="generated_content"
                    [disabled]="!hasGenerated || (showError && (tokenPromptSent >= maxTokenBackendLimit)) "
                    (click)="generate()"
                ></agpr-button>
                <agpr-button
                    id="agpr_aiRefinementDialog_copy"
                    class="agpr-aiRefinementDialog-plainButton agpr-aiRefinementDialog-generated-topSection-copy"
                    [style]="buttonTypes.icon"
                    [icon]="'fa-kit-duotone fa-agpr-copy'"
                    tooltip="Common.dialog.aiRefinement.copy"
                    tooltipPosition="left"
                    ariaLabel="Common.dialog.aiRefinement.copy"
                    [disabled]="!hasGenerated || !generatedContent || (generatedContent == '')"
                    (click)="copyGeneratedContent()"
                ></agpr-button>
            </div>

            <agpr-form-message *ngIf="showError">
                {{
                    (tokenPromptSent >= maxTokenBackendLimit) ?
                    ('Common.dialog.aiRefinement.error.limitExceeded' | localize) :
                    ('Common.dialog.aiHelper.error.description' | localize)
                }}
            </agpr-form-message>
            <div
                class="agpr-aiRefinementDialog-generated"
            >
                <agpr-scroll-panel
                    #sp
                    [agprLoading]="loading"
                    class="agpr-aiRefinementDialog-generatedContent"
                >
                    <div id="generated_content">
                        <span [innerHTML]="generatedContent | setUlStyle | sanitizeHtml"></span>
                    </div>
                </agpr-scroll-panel>

                <div
                    *ngIf="!showError"
                    class="agpr-aiRefinementDialog-generatedBottom"
                >
                <div
                    *ngIf="!hasGenerated && streamingStarted"
                    class="agpr-aiRefinementDialog-loading"
                    [agprLoading]="true"
                    [agprInlineLoadingIndicator]="true"
                    [loadingSmallIndicator]="true"
                >
                </div>
                    {{ hasGenerated ? ('Common.dialog.aiRefinement.pleaseReviewCarefully' | localize) : '' }}
                </div>
            </div>
            <agpr-panel
                #panelOriginalTextToggle
                [collapsed]="originalTextCollapsed"
                [contentPadding]="false"
                [expandIcon]="'fa-angle-down'"
                [collapseIcon]="'fa-angle-up'"
                [header]="'Common.dialog.aiRefinement.originalText'"
                [headerUppercase]="false"
                (collapsedChange)="setOriginalTextToggle($event)"
                class="agpr-aiRefinementDialog-original"
                [ngClass]="{'agpr-aiRefinementDialog-original-expanded': !originalTextCollapsed}"
                [marginTop]="0"
            >
                <agpr-scroll-panel
                    class="agpr-aiRefinementDialog-original-scroll"
                >
                    <div
                        *ngIf="!originalTextCollapsed"
                        class="agpr-aiRefinementDialog-originalContent"
                    >
                        <span [innerHTML]="selectionHtml | setUlStyle | sanitizeHtml"></span>
                    </div>
                </agpr-scroll-panel>
            </agpr-panel>
        </div>

        <!-- footer section -->
        <ng-template #footerLeft>
            <agpr-button
                id="agpr_aiRefinementDialog_cancel"
                label="Core.button.cancel"
                [style]="buttonTypes.secondary"
                (click)="cancel()"
            ></agpr-button>
        </ng-template>
        <ng-template #footerRight>
            <ng-container>
                @if (!hideInsert) {
                    <agpr-button
                        id="agpr_aiRefinementDialog_insert"
                        label="Common.dialog.aiRefinement.insert"
                        [style]="buttonTypes.primaryB"
                        (click)="insert()"
                        [disabled]="!hasGenerated || !generatedContent || (generatedContent == '')"
                    ></agpr-button>
                }
                <agpr-button
                    id="agpr_aiRefinementDialog_replace"
                    label="Common.dialog.aiRefinement.replace"
                    [style]="buttonTypes.primaryB"
                    (click)="replace()"
                    [disabled]="!hasGenerated || !generatedContent || (generatedContent == '')"
                ></agpr-button>
            </ng-container>
        </ng-template>
    </agpr-scroll-panel>
</agpr-dialog-container>
